import { render, staticRenderFns } from "./Modalities.vue?vue&type=template&id=67144970&scoped=true"
import script from "./Modalities.vue?vue&type=script&lang=js"
export * from "./Modalities.vue?vue&type=script&lang=js"
import style0 from "./Modalities.vue?vue&type=style&index=0&id=67144970&prod&lang=scss&scoped=true"
import style1 from "./Modalities.vue?vue&type=style&index=1&id=67144970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67144970",
  null
  
)

export default component.exports